import React, { FC } from 'react';
import { Collapse, Typography } from 'antd';
import { Longdash } from '~/utils';
import { useTranslation } from 'react-i18next';
import { Consent, Transaction } from '~/types';
import styled from 'styled-components';
import { useDirection } from '~/hooks';

const { Panel } = Collapse;

interface ViewMoreDetailsProps {
  result: Consent | Transaction;
}

const StyledCollapse = styled(Collapse)`
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: transparent;
`;

const PanelHeader = styled(Typography.Title)`
  && {
    margin: 0; // Increased specificity to override global styles
  }
`;

const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const LabelText = styled(Typography.Text)`
  color: #a1a0ae;
`;

const DetailText = styled(Typography.Text)`
  font-weight: 500;
`;

const ViewMoreDetails: FC<ViewMoreDetailsProps> = ({ result }) => {
  const { t } = useTranslation('sendMoney');

  const [direction] = useDirection();
  return (
    <StyledCollapse bordered={false} expandIconPosition="end" defaultActiveKey={['1']}>
      <Panel header={<PanelHeader level={4}>{t('viewMore')}</PanelHeader>} key="1">
        <DetailRow>
          <LabelText>{t('phoneNumber')}</LabelText>
          <DetailText
            style={{ direction: 'ltr', textAlign: direction === 'rtl' ? 'right' : undefined }}
          >
            {result?.details?.recipientPhoneNumber || Longdash}
          </DetailText>
        </DetailRow>
        <DetailRow>
          <LabelText>{t('beneficiaryAccount')}</LabelText>
          <DetailText>{result?.recipient?.accountNumber || Longdash}</DetailText>
        </DetailRow>
        <DetailRow>
          <LabelText>{t('beneficiaryName')}</LabelText>
          <DetailText
            style={{ direction: 'ltr', textAlign: direction === 'rtl' ? 'right' : undefined }}
          >
            {result?.details?.recipientName || Longdash}
          </DetailText>
        </DetailRow>
        <DetailRow>
          <LabelText>{t('note')}</LabelText>
          <DetailText>{result?.details?.comment || Longdash}</DetailText>
        </DetailRow>
      </Panel>
    </StyledCollapse>
  );
};

export default ViewMoreDetails;
